import React from "react";
import Relive from "../../components/relive/index";
import Classic from "../../components/Classic/index";
import Categories from "../../components/Categories/index";
import Special from "../../components/Special/index";
import Sellers from "../../components/Sellers/index";
import Testimonials from "../../components/Testimonials/index";
import UpdateHome from "../../components/UpdateHome/index";
import Follow from "../../components/Follow/index";

const Home = ({ products, loading, error }) => {
    const title = true;
 const bestSellerProducts = (products || []).filter((product) => product.bestSeller === true);
    // ✅ Filter by exact category names
    const categoriesToInclude = ["Candy", "Toffee", "Lollipop", "Premia"];
    const getOneProductPerGivenCategories = (allProducts) => {
        const selectedProducts = [];

        for (const category of categoriesToInclude) {
            const product = allProducts.find(
                (p) => p.category === category || p.categoryName === category
            );
            if (product) selectedProducts.push(product);
        }

        return selectedProducts;
    };


    const optimizedProducts = getOneProductPerGivenCategories(products || []);
    return (
        <>
            <Relive />
            <Classic titleforClassic={title} products={optimizedProducts} loading={loading} error={error} />
            <Categories />
            <Special />
            {/* ✅ Pass only 4 products from specific categories */}
            <Sellers products={bestSellerProducts} loading={loading} error={error} />
            <Testimonials />
            <UpdateHome />
            <Follow />
        </>
    );
};

export default Home;
